/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Inject,
} from '@angular/core';
import { Certification, FaqSection } from '../../shared/models';
import { AcademyCertificationsService } from '../../services/academy-certifications.service';
import { AcademyNavigationService } from '../../services/academy-navigation.service';
import { AcademyFaqComponent } from '../../shared/components/academy-faq/academy-faq.component';
import { CERTIFICATION_FAQ_SECTIONS } from '../certification-faqs.constants';

@Component({
  selector: 'ut-certification-detail',
  templateUrl: './certification-detail.component.html',
  styleUrls: ['./certification-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AcademyFaqComponent],
})
export class CertificationDetailComponent implements OnInit {
  certification: Certification | null = null;
  faqSections: FaqSection[] = CERTIFICATION_FAQ_SECTIONS;

  constructor(
    private certService: AcademyCertificationsService,
    private navService: AcademyNavigationService,
    @Inject('$state') private $state: any,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const id = Number(this.$state.params?.certificationId);
    this.certService.getCertification(id).subscribe(cert => {
      if (!cert || cert.status === 'locked' || cert.status === 'completed') {
        this.navService.goToAcademyHome();
        return;
      }
      this.certification = cert;
      this.cdr.markForCheck();
    });
  }

  goBack(): void {
    this.navService.goToCertifications();
  }
}
